import { Paperclip } from "lucide-react";
import { AttachmentDownloadButton } from "./AttachmentDownloadButton";
import { useRequestComments } from "./useOrderSupportRequests";

interface RequestAttachmentsProps {
  orderId: string;
  zendeskTicketId: number;
}

/**
 * "Anexos" da solicitação (protótipo 2b): os arquivos que o cliente enviou ao abrir o chamado. Vêm do Zendesk na
 * mesma consulta das respostas; carregamento e erro ficam por conta da seção "Últimas interações".
 */
export const RequestAttachments = ({ orderId, zendeskTicketId }: RequestAttachmentsProps) => {
  const { data } = useRequestComments(orderId, zendeskTicketId);
  const attachments = data?.requestAttachments ?? [];
  if (attachments.length === 0) return null;

  return (
    <section className="flex flex-col gap-2.5 rounded-[10px] border px-5 py-4" aria-labelledby="request-attachments-title">
      <h3
        id="request-attachments-title"
        className="flex items-center gap-1.5 text-[13px] text-muted-foreground"
      >
        <Paperclip className="h-3.5 w-3.5" aria-hidden="true" />
        Anexos enviados · {attachments.length} {attachments.length === 1 ? "arquivo" : "arquivos"}
      </h3>
      <ul className="flex flex-wrap gap-2">
        {attachments.map((attachment) => (
          <li key={attachment.id}>
            <AttachmentDownloadButton orderId={orderId} zendeskTicketId={zendeskTicketId} attachment={attachment} />
          </li>
        ))}
      </ul>
    </section>
  );
};
